import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {

    name: string;
    spinner = true;

    constructor(
        public dialogRef: MdDialogRef<ErrorDialogComponent>,
        @Inject(MD_DIALOG_DATA) public data: any
    ) {

    }
    closeDialog(): void {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/servicereport/components/error-dialog/error-dialog.component.ts